// extracted by mini-css-extract-plugin
export default {"container":"AboutPage_container__ufECk","contact":"AboutPage_contact__k5Bs2"};